import * as yup from 'yup';

export default yup.object().shape({
  name: yup.string().trim().required(),
  description: yup.string().trim(),
  isPublic: yup.boolean().required(),
  isEditable: yup.boolean().required(),
  type: yup.string().required(),
});
